var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuBars = function SvgMenuBars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.25c0-.311.25-.562.563-.562h9.375a.561.561 0 1 1 0 1.125H2.313a.56.56 0 0 1-.563-.563m0 3.75c0-.311.25-.562.563-.562h9.375a.561.561 0 1 1 0 1.125H2.313A.56.56 0 0 1 1.75 7m10.5 3.75c0 .312-.25.563-.562.563H2.313a.56.56 0 0 1-.563-.563c0-.311.25-.562.563-.562h9.375c.311 0 .562.25.562.562"
  })));
};
export default SvgMenuBars;